export const accordionItems = [
  {
    value: [
      {
        id: "A",
        title: "The Introduction to Facebook Page Monetization Program",
        link: "https://www.youtube.com/embed/V68xMTqifoE?si=wES1-iemf9cbzmmi",
      },
      {
        id: "B",
        title: "Meta/Facebook Blueprint",
        link: "https://www.youtube.com/embed/ADwfwkzs2Do?si=Vlz8c7TJhGMSQobt",
      },
      {
        id: "C",
        title: "Facebook Account Verification",
        link: "https://www.youtube.com/embed/FmFzsMzEpBw?si=RYub42IOlN8eoQQe",
      },
    ],
  },

  {
    value: [
      {
        id: "A",
        title: "Facebook Business Manager Secret",
        link: "https://www.youtube.com/embed/tps5jzlnKOs?si=KK47zxn7ewqjoU9x",
      },
      {
        id: "B",
        title: "Facebook Page Monetization Secrets",
        link: "https://www.youtube.com/embed/CF2W2y5i7JY?si=TiFfqtPusULi0E7L",
      },
    ],
  },

  {
    value: [
        {
            id: "A",
            title: "Content Monetization Secrets",
            link: "https://www.youtube.com/embed/p1U0kDZqg_M?si=KMN9XOnJhzpInZAa" , 
        },
    ],
  },

  {
    value: [
        {
            id: "A",
            title: "Branded Content Monetization Tools",
            link: "https://www.youtube.com/embed/R5MC4GNCP_Q?si=y2w3Jm7tnFMl9o0-" , 
        },
        {
            id: "B",
            title: "Branded Content Partnership Secrets",
            link: "https://www.youtube.com/embed/hnWdJTjoh-o?si=J4OamOk6p7P1Ez_w" , 
        },
    ],
  },

  {
    value: [

    ],
  },

  {
    value: [
        {
            id: "A",
            title: "Facebook Ads Secrets",
            link: "https://www.youtube.com/embed/rAd8vqdzYAM?si=Nf_pNTpOkO9ofiwk",
        },
    ],
  },

  {
    value: [
        {
            id: "A",
            title: "Twitter Ads Secrets",
            link: "https://www.youtube.com/embed/Yu4oiiYRRk8?si=7CqY9spYxiT-",
        },
    ],
  },

  {
    value: [
        {
            id: "A",
            title: "Youtube Ads Secrets",
            link: "https://www.youtube.com/embed/Z6tUQXMwx2w?si=xO1spPH1To6FaUVG" ,
        },
    ],
  },

  {
    value: [

    ],
  },

  {
    value: [

    ],
  },

  {
    value: [

    ],
  },

  {
    value: [

    ],
  },

  {
    value: [

    ],
  },

  {
    value: [

    ],
  },

  {
    value: [

    ],
  },
];
